import DownloadButton from "@buttons/DownloadButton";
import React from "react";
import { Button, Checkbox, Dropdown } from "semantic-ui-react";

const CollectionFilters = (props) => {
  const {
    onExportClick,
    onVarianceHistoryClick,
    to,
    disabled,
    onRefreshClick,
    periods,
    from,
    onChange,
    currentWeek,
    onChangeCurrentWeek,
    showVarianceHistory,
    loading,
    loadingExport,
    showDetails,
  } = props;

  return (
    <>
      <DownloadButton
        loading={loadingExport}
        onClick={onExportClick}
        className="mr-1"
      />
      From:
      <Dropdown
        selection
        search
        options={periods}
        name="from"
        value={from}
        onChange={onChange}
        className="ml-1 mr-1"
      />
      {!currentWeek && (
        <>
          To:
          <Dropdown
            selection
            options={periods}
            name="to"
            value={to}
            onChange={onChange}
            disabled={currentWeek}
            className="ml-1"
          />
        </>
      )}
      <Checkbox
        className="ml-1"
        label="Current Week"
        checked={currentWeek}
        onChange={onChangeCurrentWeek}
      />
      {showVarianceHistory && (
        <Button
          disabled={loading || disabled}
          onClick={onVarianceHistoryClick}
          color="blue"
          floated="right"
        >
          Site Variance History
        </Button>
      )}
      <Button
        disabled={loading || disabled || periods.length < 1}
        className="ml-1"
        onClick={onRefreshClick}
        positive
      >
        Refresh
      </Button>
      {props.isPerformance && (
        <Checkbox
          className="ml-1"
          checked={showDetails}
          label="Show Details"
          onChange={(e) =>
            onChange(e, { name: "showDetails", value: !showDetails })
          }
          name="showDetails"
          toggle
        />
      )}
    </>
  );
};

export default CollectionFilters;
